import { Card, CardContent } from '@/components/ui/card';
import { CheckCircle2 } from 'lucide-react';

export const SustainabilitySection = () => {
  const benefits = [
    'Speicherung von PV-Überschuss tagsüber für nächtlichen Betrieb',
    'Glättung von Einspeiseschwankungen bei Windkraft',
    'Teilnahme an Regelenergiemärkten für zusätzliche Erlöse',
    'Beitrag zu Science-Based Targets und ESG-Zielen',
  ];

  return (
    <section id="sustainability" className="py-12 sm:py-24 bg-background" data-testid="sustainability-section">
      <div className="container mx-auto px-4">
        <div className="max-w-6xl mx-auto">
          <div className="grid md:grid-cols-2 gap-10 lg:gap-16 items-center">
            {/* Left Content */}
            <div className="space-y-8">
              <div>
                <p className="text-base sm:text-xl text-muted-foreground font-normal mb-2">
                  BESS und erneuerbare Energien:
                </p>
                <h2 className="font-heading font-bold text-2xl sm:text-4xl lg:text-5xl text-primary mb-6">
                  Eine nachhaltige Kombination
                </h2>
                <p className="text-lg text-muted-foreground leading-relaxed">
                  Rechenzentren stehen unter wachsendem Druck, ihren
                  CO₂-Fußabdruck zu reduzieren. BESS ist der Schlüssel, um volatile
                  Solar- und Windenergie zuverlässig nutzbar zu machen – rund um
                  die Uhr.
                </p>
              </div>

              {/* Benefits List */}
              <div className="space-y-5">
                {benefits.map((benefit, index) => (
                  <div key={index} className="flex items-start space-x-3">
                    <CheckCircle2 className="w-5 h-5 text-success flex-shrink-0 mt-1" />
                    <p className="text-foreground leading-relaxed">
                      {benefit}
                    </p>
                  </div>
                ))}
              </div>
            </div>

            {/* Right – Image Card */}
            <div className="space-y-4">
              <Card className="border border-border shadow-md overflow-hidden" data-testid="sustainability-image-card">
                <CardContent className="p-0">
                  <img
                    src="https://customer-assets.emergentagent.com/job_datacenter-energy-1/artifacts/00froz73_SolarParkBESS.png"
                    alt="Solar Park with BESS"
                    className="w-full aspect-[4/3] object-cover"
                    loading="lazy"
                    data-testid="sustainability-image"
                  />
                </CardContent>
              </Card>

              {/* Stats Bar */}
              <Card className="border border-secondary/20 shadow-sm" data-testid="sustainability-stats">
                <CardContent className="p-5">
                  <div className="grid grid-cols-2 gap-4 text-center">
                    <div>
                      <div className="font-heading font-bold text-3xl text-secondary mb-1">
                        70%
                      </div>
                      <div className="text-sm text-muted-foreground">
                        Eigenverbrauchsquote
                      </div>
                    </div>
                    <div className="border-l border-border">
                      <div className="font-heading font-bold text-3xl text-secondary mb-1">
                        100%
                      </div>
                      <div className="text-sm text-muted-foreground">
                        Erneuerbare Energie
                      </div>
                    </div>
                  </div>
                </CardContent>
              </Card>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
